<template>
    <div class="main-content">
        <b-card>Lista de notificações</b-card>
    </div>
</template>

<script>
export default {
    name: 'Notifications',
}
</script>
